import React from "react";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Ballloon = (props) => {
    return (
        <div className={props.className + " icon-bg-circle icon-bg-" + props.color}>
            <FontAwesomeIcon icon={props.icon} className={"icon-lg icon-" + props.color} />
        </div>
    );
}

Ballloon.defaultProps = {
    color: "blue"
}

Ballloon.propTypes = {
    color: PropTypes.string
};

export default Ballloon;